import { createContext } from 'react';

import { CustomerData } from '@funnels/types';

export const INITIAL_CUSTOMERS_CONTEXT_DATA: CustomerData[] = [];

export const CustomersContext = createContext<CustomerData[]>(INITIAL_CUSTOMERS_CONTEXT_DATA);
